/* eslint-disable tailwindcss/no-arbitrary-value */
import cn from 'classnames';
import { DayPicker, type PropsSingle } from 'react-day-picker';
import { MobileMonthNavigation } from './MobileMonthNavigation';
import Button from '$/components/Button';

type SingleDayPickerProps = PropsSingle & { mode: 'single' };

type SingleDateCalendarProps = {
  dayPickerProps: SingleDayPickerProps;
  isMobileSingleMonth: boolean;
  canGoToPreviousMonth: boolean;
  canGoToNextMonth: boolean;
  onPreviousMonthClick: () => void;
  onNextMonthClick: () => void;
  onDoneClick: () => void;
  doneLabel: string;
};

export function SingleDateCalendar({
  dayPickerProps,
  isMobileSingleMonth,
  canGoToPreviousMonth,
  canGoToNextMonth,
  onPreviousMonthClick,
  onNextMonthClick,
  onDoneClick,
  doneLabel,
}: SingleDateCalendarProps): JSX.Element {
  return (
    <div
      className={cn('date-range-picker', {
        'relative date-range-picker--mobile': isMobileSingleMonth,
      })}
    >
      <div
        className={cn('px-[--spacing-padding-x] py-[--spacing-padding-y-sm]', {
          'overflow-visible': isMobileSingleMonth,
        })}
      >
        {isMobileSingleMonth && (
          <MobileMonthNavigation
            canGoToNextMonth={canGoToNextMonth}
            canGoToPreviousMonth={canGoToPreviousMonth}
            onNextMonthClick={onNextMonthClick}
            onPreviousMonthClick={onPreviousMonthClick}
          />
        )}
        <DayPicker {...dayPickerProps} />
      </div>
      <div className="flex justify-end border-t border-t-borders/default px-[--spacing-padding-x] py-[--spacing-padding-y-sm]">
        <Button
          onClick={onDoneClick}
          styleType="primary"
          type="button"
          variant="outline"
        >
          {doneLabel}
        </Button>
      </div>
    </div>
  );
}
